// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Yiyn","placeholdersHeader":"styles_placeholdersHeader__1z7vp","editorStyle":"styles_editorStyle__29XZb","placeholdersBox":"styles_placeholdersBox__3Ug8I"};